import React from 'react';
import OddsButton from '../../../ui/Button';
import { NotificationManager } from 'react-notifications';
import { detectError, getErrorByCode } from '../../../utils/Helper';
import { checkComboIsActive, getVaixEventsIds } from '../helper';
import { trackEvents } from '../../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATIONS,
    VAIX_TRACKING_TYPE,
} from '../../../constants/vaix/VaixTrcakingConstants';
import {
    AddMultipleBets,
    RemoveMultipleBets,
} from '../../../actions/BetslipActions';
import { connect } from 'react-redux';

const CombosButton = ({
    markets,
    betslip,
    addMultipleBets,
    removeMultipleBets,
    position,
    userId,
    isModal,
    closeModalHandler = () => {},
}) => {
    const onButtonClickHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let hasMarkets = betslip.hasMarkets;

        if (betslip.customBetEventId === null) {
            if (hasMarkets.length > 0) {
                if (areAllMarketsAdded()) {
                    let ids = [];
                    markets.betItems.map((item) => {
                        ids.push({ gameId: item.market.marketId });
                    });
                    removeMultipleBets(ids);
                    if (isModal) {
                        closeModalHandler();
                    }
                } else if (isNonComboMarketAdded()) {
                    NotificationManager.error(
                        getErrorByCode('BAD_COMBINATION')
                    );
                } else if (checkLimit(hasMarkets)) {
                    NotificationManager.error(detectError('MARKET_LIMIT'));
                } else {
                    trackCombo();
                    addMarkets();
                    if (isModal) {
                        closeModalHandler();
                    }
                }
            } else {
                addMarkets();
                trackCombo();
                if (isModal) {
                    closeModalHandler();
                }
            }
        } else {
            NotificationManager.error(getErrorByCode('BAD_COMBINATION'));
        }
    };

    const addMarkets = () => {
        let data = [];
        markets.betItems.map((item) => {
            data.push({
                odds: item.outcome.odds,
                live: '0',
                betId: item.outcome.betNr,
                gameId: item.market.marketId,
            });
        });
        addMultipleBets(data);
    };

    const checkLimit = (hasMarkets) => {
        return (
            hasMarkets.length > 15 ||
            hasMarkets.length +
                markets.betItems.length -
                getAmountOfAddedMarkets() >
                15
        );
    };

    const areAllMarketsAdded = () => {
        return markets.betItems.every((item) => {
            return checkComboIsActive(item, betslip.setMarketsNew);
        });
    };

    const isNonComboMarketAdded = () => {
        return markets.betItems.some((item) => {
            return (
                betslip.betList.some(
                    (event) => event.eventId === item.market.eventId
                ) && !checkComboIsActive(item, betslip.setMarketsNew)
            );
        });
    };

    const getAmountOfAddedMarkets = () => {
        let count = 0;
        markets.betItems.map((item) => {
            checkComboIsActive(item, betslip.setMarketsNew) && count++;
        });
        return count;
    };

    const trackCombo = () => {
        let vaixData = [];
        vaixData.push(...getVaixEventsIds(markets, true));

        trackEvents(
            vaixData,
            VAIX_TRACKING_TYPE.clickCombinations,
            VAIX_TRACKING_LOCATIONS.combos,
            '/sport/',
            userId,
            0,
            position
        );
    };
    return (
        <OddsButton
            onClick={onButtonClickHandler}
            height={'40px'}
            margin={'0'}
            width={'100%'}
            padding={'11px'}
            fontSize={'13px'}
            oddsYellow
            active={areAllMarketsAdded(markets)}
        >
            {markets.odds.toFixed(2)}
        </OddsButton>
    );
};

function mapStateToProps(state) {
    return { betslip: state.betslip };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addMultipleBets: (data) => dispatch(AddMultipleBets(data)),
        removeMultipleBets: (data) => dispatch(RemoveMultipleBets(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CombosButton);
